import { Navigation } from "zudoku";
import { sidebar } from "./overview/sidebar"
import { BeyondSandbox } from "../../src/pages/BeyondSandbox";
import { BeyondCompliance } from "../../src/pages/BeyondCompliance";
import { LandingPage } from "../../src/pages/LandingPage";

export const navigation: Navigation = [
    {
      type: "custom-page",
      label: "Home",
      path: '/',
      element: <LandingPage />,
      display: 'hide',
    },
    {
      type: "category",
      icon: "home",
      label: "Overview",
      items: sidebar
    },
    {
      type: "category",
      icon: "codesandbox",
      label: "Beyond Sandbox",
      items: [
        {
          type: 'doc',
          label: "Overview",
          file: "products/beyond-sandbox"
        },
        {
          type: 'doc',
          label: "Authentication",
          file: "products/beyond-sandbox-authentication"
        },
        {
          type: 'custom-page',
          label: 'APIs',
          path: 'products/beyond-sandbox/apis',
          element: <BeyondSandbox />
        }
      ]
    },
    {
      type: 'category',
      icon: 'clipboard-list',
      label: 'Beyond Compliance',
      items: [
        {
          type: 'doc',
          label: "Overview",
          file: "products/beyond-compliance"
        },
        {
            type: 'doc',
          label: "Authentication",
          file: "products/beyond-compliance-authentication"
        },
        {
          type: 'custom-page',
          label: 'APIs',
          path: 'products/beyond-compliance/apis',
          element: <BeyondCompliance />
        }
      ]
    },
    {
      type: 'category',
      icon: 'banknote',
      label: 'Beyond Cash',
      items: [
        {
          type: 'doc',
          label: 'Overview',
          file: 'products/beyond-cash'
        }
      ]
    },
    {
      type: 'link',
      icon: 'scale',
      label: 'Tax Compliance Gateway',
      to: 'products/tax-collection-gateway/api-reference'
    }
]
